<template>
  <a-modal
    :visible="visible"
    :title="title"
    @cancel="handleCancel"
    width="600px"
  >
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item :label="$t('直播课程.课程')" prop="courseId">
        <a-select v-model="form.courseId" @change="handleCourseChange">
          <a-select-option v-for="item in courseList" :key="item.id" :value="item.id">
            {{ item.courseTitle }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('直播课程.章节')" prop="chapterId">
        <a-select v-model="form.chapterId">
          <a-select-option v-for="item in chapterList" :key="item.id" :value="item.id">
            {{ item.chapterName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('直播课程.小节数')" prop="sectionNumber">
        <a-input-number v-model="form.sectionNumber" :min="1" style="width: 100%" />
      </a-form-model-item>
      <a-form-model-item :label="$t('直播课程.小节名称')" prop="sectionName">
        <a-input v-model="form.sectionName" :maxLength="255" />
      </a-form-model-item>
      <a-form-model-item label="排序序号" prop="sort">
        <a-input-number v-model="form.sort" :min="0" style="width: 100%" />
      </a-form-model-item>
      <a-form-model-item label="推荐到首页" prop="isRecommend">
        <a-select v-model="form.isRecommend" placeholder="请选择是否推荐到首页">
          <a-select-option :value="0">否</a-select-option>
          <a-select-option :value="1">是</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('直播课程.预计开播时间')" prop="scheduledTime">
        <a-date-picker v-model="form.scheduledStartTime" show-time format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" style="width: 100%" />
      </a-form-model-item>
    </a-form-model>
    <template slot="footer">
      <a-button @click="handleCancel">{{$t('通用.按钮.取消')}}</a-button>
      <a-button type="primary" @click="submitForm">{{$t('通用.按钮.确定')}}</a-button>
    </template>
  </a-modal>
</template>

<script>
import { addLiveCourseSection, updateLiveCourseSection } from '@/api/livecourse/liveCourseSection'
import { listLiveCourseChapter } from '@/api/livecourse/liveCourseChapter'

export default {
  name: 'CreateForm',
  props: {
    courseList: {
      type: Array,
      default: () => []
    },
    chapterList: {
      type: Array,
      default: () => []
    },
    courseId: {
      type: [String, Number],
      default: null
    },
    chapterId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      visible: false,
      title: '',
      form: {
        id: undefined,
        courseId: undefined,
        chapterId: undefined,
        sectionNumber: undefined,
        sectionName: undefined,
        sort: 0,
        isRecommend: 0,
        scheduledStartTime: undefined
      },
      chapterList: [],
      rules: {
        courseId: [{ required: true, message: '请选择课程', trigger: 'change' }],
        chapterId: [{ required: true, message: '请选择章节', trigger: 'change' }],
        sectionNumber: [{ required: true, message: '请输入小节数', trigger: 'blur' }],
        sectionName: [{ required: true, message: '请输入小节名称', trigger: 'blur' }],
        isRecommend: [{ required: true, message: '请选择是否推荐到首页', trigger: 'change' }]
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 16 }
    }
  },
  methods: {
    handleAdd() {
      this.title = '新增小节'
      this.form = {
        id: undefined,
        courseId: this.courseId,
        chapterId: this.chapterId,
        sectionNumber: undefined,
        sectionName: undefined,
        sort: 0,
        isRecommend: 0,
        scheduledStartTime: undefined
      }
      // 如果没有chapterList，且有courseId，则获取章节列表
      if (!this.chapterList || this.chapterList.length === 0) {
        if (this.form.courseId) {
          listLiveCourseChapter({ courseId: this.form.courseId }).then(response => {
            this.chapterList = response.data
          })
        }
      }
      this.visible = true
    },
    handleUpdate(row) {
      this.title = '修改小节'
      this.form = { ...row }
      this.chapterList = []
      if (row.courseId) {
        listLiveCourseChapter({ courseId: row.courseId }).then(response => {
          this.chapterList = response.data
        })
      }
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    },
    handleCourseChange(courseId) {
      this.form.chapterId = undefined
      this.chapterList = []
      if (courseId) {
        listLiveCourseChapter({ courseId }).then(response => {
          this.chapterList = response.data
        })
      }
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.id) {
            updateLiveCourseSection(this.form).then(() => {
              this.$message.success('修改成功')
              this.visible = false
              this.$emit('ok')
            })
          } else {
            addLiveCourseSection(this.form).then(() => {
              this.$message.success('新增成功')
              this.visible = false
              this.$emit('ok')
            })
          }
        }
      })
    }
  }
}
</script>